import { Box, Button, OutlinedInput } from "@mui/material";
import { BackgroundStyle, BigHeading, FlexContainer, LightBlueContainer, ListContainer, SearchingBoxContainer, LongBlueButton } from "../assets/style";
import RecordTable, { TableRow, TableHeader } from "../components/RecordTable";
import { useState, useContext, useEffect } from "react";
import SearchInput from "../components/SearchInput";
import SearchDatePicker from "../components/SearchDatePicker";
import dayjs from 'dayjs';
import SearchBox from "../components/SearchBox";
import MainContent from '../components/MainContent';
import { useNavigate } from "react-router-dom";
import { companyPageName } from "../components/PageName";
import { GlobalStateContext } from "../store/GlobalState";
import LogoutFunction from '../components/LogoutFunction';
import { useLazyGetCompanyListingQuery } from "../features/comapny/comapnySlice";
import FormDropDownList from "../components/FormDropDownList";
import RecordTableV2 from "../components/RecordTableV2";
import { RecordModel } from "../models/RecordModel";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectPermissions } from "../features/auth/authSlice";
import { Permissions } from "../utils/Permissions";

const CompanyListPage = () => {
    const { t, i18n } = useTranslation();
    const [companyName, setCompanyName] = useState("");
    const [isActive, setIsActive] = useState(true);
    const navigate = useNavigate();
    const [getCompanyListingQuery] = useLazyGetCompanyListingQuery();
    const globalState = useContext(GlobalStateContext);
    const columns: TableHeader[] = [
        { field: 'name', headerName: t('Company Name'), width: 400, isSortable: true },
        { field: 'isActive', headerName: t('Is Active'), width: 200, isSortable: true },
        { field: 'lastUpdatedAt', headerName: t('Last Updated At'), width: 200, isSortable: true },
        { field: 'lastUpdatedBy', headerName: t('Last Updated By'), width: 400, isSortable: true },
    ];
    const [tableRows, setTableRows] = useState<any[]>([]);
    const [data, setData] = useState<RecordModel<any>>();
    const permissions = useSelector(selectPermissions)

    useEffect(() => {
        handleTableData()
    }, []);

    const fetchDataForPage = async (pageNumber: any) => {
        // Fetch data for the specified page from the backend
        const data = await getCompanyListingQuery(
            {
                name: companyName?.toString(),
                isActive: isActive?.toString(),
                page: pageNumber
            }
        );
        if (data.status === 'fulfilled') {
            return data.data.records.map((item: any) => ({
                id: item?.id,
                name: item?.name,
                isActive: item?.isActive,
                lastUpdatedAt: item?.lastUpdatedAt,
                lastUpdatedBy: item?.lastUpdatedBy,
            }))
        }
        // return [];
    };

    const handleTableData = async () => {
        try {
            console.log("getting data")
            if (localStorage.accessToken) {
                getCompanyListingQuery(
                    {
                        name: companyName?.toString(),
                        isActive: isActive?.toString(),
                    }
                ).then(
                    (res) => {
                        if (res.status == 'fulfilled') {

                            const tableRows = res?.data.records.map((item: any) => ({
                                id: item?.id,
                                name: item?.name,
                                isActive: item?.isActive,
                                lastUpdatedAt: item?.lastUpdatedAt,
                                lastUpdatedBy: item?.lastUpdatedBy,
                            }))
                            setTableRows(tableRows)
                            setData(res?.data)
                        }
                    }
                )
            }
        } catch (error) {
            // alert('An error occurred. Please refresh (F5) or login again.');
            // console.log(error)
        } finally {
            // setIsLoading(false); 
        }
    }


    const handleRowClick = (company: any) => {
        // Handle the row click event and pass the row value to another page or component
        console.log("company, ", company)
        navigate('/company-detail', { state: company });
    };

    const handleContractNumChange = (e: any) => {
        setIsActive(!isActive)
    };


    return (
        <MainContent type={companyPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <ListContainer className="data-table-overide-styles">
                    <BigHeading>{t("Company")}</BigHeading>
                    <SearchingBoxContainer>
                        <SearchBox>
                            <FlexContainer>
                                <SearchInput title={t("Company Name")} value={companyName} setMethod={setCompanyName} />
                                {/* <SearchInput title={"Is Active"} value={isActive} setMethod={setIsActive} /> */}
                                <FormDropDownList
                                    sameRowTitle={t("Is Active")}
                                    value={isActive}
                                    handleValueChange={handleContractNumChange}
                                    items={['true', 'false']}
                                />
                            </FlexContainer>

                            <FlexContainer>
                                <LongBlueButton onClick={() => handleTableData()}>{t("Search")}</LongBlueButton>
                            </FlexContainer>

                            {
                                permissions.includes(Permissions.CompanyEdit)
                                &&
                                <FlexContainer>
                                    <LongBlueButton onClick={() => { navigate('/add-company') }}>{t("Add New Company")}</LongBlueButton>
                                </FlexContainer>
                            }
                        </SearchBox>
                    </SearchingBoxContainer>
                    {/* <RecordTable columns={columns} rows={tableRows} checkbox={false} onClick={handleRowClick}></RecordTable> */}
                    <RecordTableV2
                        columns={columns}
                        rows={tableRows}
                        checkbox={false}
                        pages={data?.totalPages}
                        totalCount={data?.totalCount}
                        onClick={handleRowClick}
                        updateTableRows={setTableRows}
                        fetchDataForPage={fetchDataForPage}
                    ></RecordTableV2>
                </ListContainer>
            </BackgroundStyle>
        </MainContent >
    );
};
export default CompanyListPage;